import React from "react";
import { Stagger, StaggerItem } from "../lib/motion";

const STEPS = [
  {
    n: 1,
    title: "Tell us your chart",
    body: "Birth date, time, place. That's all a proper reading needs. A named consultant — who earns nothing from what you eventually buy — takes it from there. Your reading is written up and sent to you within [fill in your real turnaround].",
  },
  {
    n: 2,
    title: "Read it. Then pick.",
    body: "It names the graha your chart points to, and the stones or rudraksha classically read with it. You pick from what's named. Nothing's pre-selected for you, and you're not charged until you do.",
  },
  {
    n: 3,
    title: "Add on if you want",
    body: "A setting. Energisation. Another bead for a mala. All optional, all priced upfront — nothing gets added at the last step.",
  },
  {
    n: 4,
    title: "We check it, then ship it",
    body: "Gemstones go out with a report number you can verify yourself on the lab's site. Rudraksha go out with the radiograph. Insured, tracked, wherever you are.",
  },
];

/**
 * The step marker matches the proof block's report-number treatment used
 * elsewhere on the homepage (see `Ordinal` in Primitives.jsx and the ProofCard
 * head row): bold tabular Inter numerals in gold, letter-spaced, sitting above
 * a thin baseline rule — no box, no diamond.
 */
export function ProcessRail() {
  return (
    <Stagger
      className="grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-7"
      stagger={0.09}
      data-testid="process-rail"
    >
      {STEPS.map((s) => (
        <StaggerItem key={s.n} data-testid={`process-step-${s.n}`}>
          <div className="flex items-baseline gap-4 pb-3">
            <span
              className="num text-[34px] font-semibold leading-none text-gold sm:text-[38px]"
              style={{
                fontFamily: "Inter, sans-serif",
                letterSpacing: "0.04em",
                fontVariantNumeric: "tabular-nums",
              }}
              aria-hidden="true"
            >
              {String(s.n).padStart(2, "0")}
            </span>
            <span className="h-px flex-1 bg-rule" aria-hidden="true" />
          </div>

          <h3
            className="mt-4 text-[16px] leading-snug tracking-[-0.005em]"
            style={{ fontFamily: "Fraunces, Georgia, serif" }}
          >
            {s.title}
          </h3>
          <p className="mt-2.5 text-[14px] leading-[1.75] text-dim">{s.body}</p>
        </StaggerItem>
      ))}
    </Stagger>
  );
}
